export { default as Header } from "./Header";
export { default as Home } from "./Home";
export { default as About } from "./About";
export { default as Contact } from "./Contact";
export { default as NotFound } from "./NotFound";
export { default as Footer } from "./Footer";

export { default as Shop } from "./Shop";
